import { render, staticRenderFns } from "./FinanceDetailsView.vue?vue&type=template&id=6cd904c0&"
import script from "./FinanceDetailsView.vue?vue&type=script&lang=ts&"
export * from "./FinanceDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports